import React from 'react';
import { Route, Switch } from 'react-router';
import ContactRouter from './Contacts';
import CustomerRouter from './Customers';

const CrmRouter = ({ match }) => {
  return (
    <Switch>
      <Route path='/dashboard/crm/customers' component={CustomerRouter} />
      <Route path='/dashboard/crm/contacts' component={ContactRouter} />
    </Switch>
  );
};

export default CrmRouter;
